import { render, staticRenderFns } from "./ResetEmailPassworld.vue?vue&type=template&id=0f71d688&scoped=true"
import script from "./ResetEmailPassworld.vue?vue&type=script&lang=js"
export * from "./ResetEmailPassworld.vue?vue&type=script&lang=js"
import style0 from "./ResetEmailPassworld.vue?vue&type=style&index=0&id=0f71d688&prod&scoped=true&lang=css"
import style1 from "./ResetEmailPassworld.vue?vue&type=style&index=1&id=0f71d688&prod&lang=css"
import style2 from "./ResetEmailPassworld.vue?vue&type=style&index=2&id=0f71d688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f71d688",
  null
  
)

export default component.exports